// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
let __webpack_exports___1 = __webpack_require__("./src/pages/@templates/TPSubject@2026/index.ts");
let __webpack_exports__ = __webpack_require__("./src/pages/@templates/TPSubject@2026/index.css");
__webpack_exports___1 = await __webpack_exports___1;
